<template>
  <div class="animated fadeIn" id="lancamento-apontamentos">
    <header-lancamento 
      :set-date-callback="selectDate"
      :reload-callback="carregarApontamentos"
      :total-horas="getDuracao(totalHoras)"
      :data-selecionada="data"
    ></header-lancamento>

    <div class="registers">
      <div class="list">
        <template v-if="carregando">
          <div class="loading-list">
            <div class="card-loader card-loader--tabs"></div>
            <div class="card-loader card-loader--tabs"></div>
            <div class="card-loader card-loader--tabs"></div>
            <div class="card-loader card-loader--tabs"></div>
          </div>
        </template>
        <template v-else-if="apontamentos.length">
          <card-apontamento
            v-for="(item, index) in apontamentos"
            :key="index"
            :apontamento="item"
            :onClick="editar"
            :currentDate="dataSelecionada"
            @duplicate="duplicarApontamento"
            @duplicate-with-date="duplicarApontamentoEmData"
          ></card-apontamento>
        </template>
        <template v-else>
          <div class="no-register">
            <i class="fa fa-frown-o" aria-hidden="true"></i>
            <h3>Ops...</h3>
            <h5>Parece que você não possui nenhum apontamento neste dia.</h5>
          </div>
        </template>
      </div>
      <div class="details">
        <detalhes :competencia-bloqueada="competenciaBloqueada"
          :apontamento="apontamento"
          :data-selecionada="dataSelecionada"
          :callback-success="carregarApontamentos">
        </detalhes>
      </div>
    </div>

    <notifications group="apontamentos" />
  </div>
</template>

<style lang="scss">
  #lancamento-apontamentos {
    .registers {
      display: flex;
      flex-direction: row;

      .list {
        flex: 3;
        margin-right: 15px;

        .no-register {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          height: calc(100% - 15px);
          background-color: white;
          border-radius: 0 0 0 15px;
          margin-bottom: 15px;
          border: 1px solid #ccc;
          color: #4f5963;

          i {
            font-size: 15vh;
            color: #4a545d;
            margin-bottom: 15px;
          }

          h3 {
            font-size: 35px;
          }
        }
      }

      .details {
        flex: 1;
      }

      .loading-list {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .card-loader {
          width: 100%;
          /* height: 85px; */
          border-radius: 15px;
        }
      }
    }
  }
</style>

<script>
import VueTimepicker from 'vue2-timepicker'
import moment from 'moment';
import vueSlider from 'vue-slider-component';

import { setTimeout } from 'timers';

// Componentes Locais
import Detalhes from './partials/Detalhes';
import HeaderLancamento from './partials/HeaderLancamento';
import CardApontamento from './partials/CardApontamento'
import Uteis from '@/mixins/utils.js';

export default {
  components: {
    VueTimepicker,
    vueSlider,
    // Componentes locais
    HeaderLancamento,
    CardApontamento,
    Detalhes,
  },

  mixins: [
    Uteis,
  ],

  data() {
    return {
      data: null,
      competenciaBloqueada: false,
      horasRep: 0,
      apontamentos: [],
      apontamento: {},
      carregando: false,
      calculandoHoras: false,
    };
  },

  computed: {
    horasDisponiveis() {
      let tempoDisponivel = 8 * 3600;
      this.apontamentos.map(item => tempoDisponivel -= item.duracao);
      return tempoDisponivel;
    },

    dataSelecionada() {
      return new Date(this.data).toISOString().slice(0,10);
    },

    totalHoras() {
      if (this.apontamentos.length) {
        let total = 0;
        this.apontamentos.map((item) => total += item.duracao);

        return total;
      }

      return 0;
    },

    isDataAtual() {
      return this.dataSelecionada === new Date().toISOString().slice(0,10) || new Date(this.data) >= new Date();
    },
  },

  mounted() {
    this.data = new Date();
  },

  watch: {
    data() {
      this.calculandoHoras = !this.isDataAtual;

      // Verificação para pesquisar somente se o usuário ficou
      // meio segundo na data
      const data = this.data;
      this.carregando = true;

      setTimeout(() => {
        if (this.data === data) {
          this.carregarApontamentos();
        }
      }, 500);
    },
  },

  methods: {
    /**
     * Métodos que carregam informações em tela
     */

    async carregarApontamentos() {
      try {
        this.carregando = true;
        await this.carregarCompetencia();

        const filter = { filters: { data: this.dataSelecionada } };
        const apontamentos = await this.$http.get(`/apontamento/data/${this.dataSelecionada}`, filter);
        this.apontamentos = apontamentos.data.apontamentos;
        await this.carregarSugestoes();
      } catch(e) {
        console.error(e);
        this.notificar('Ocorreu um erro ao carregar os Apontamentos.', 'apontamentos');
      } finally {
        this.carregando = false;
        // this.getHorasREP();
      }
    },

    async carregarSugestoes() {
      try {
        const dataFormatada = moment(this.data, ['DD/MM/YYYY', 'M/D/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY');
        const sugestoes = await this.$http.get(`/apontamento/sugestoes`, { params: { data: dataFormatada } });

        this.processarSugestoes(sugestoes.data.suggestions);
      } catch(e) {
        console.error(e);
        this.notificar('Ocorreu um erro ao carregar as Sugestões.', 'apontamentos');
      }
    },

    async getHorasREP() {
      this.horasRep = 0;

      if (this.isDataAtual) {
        return false;
      }

      try {
        this.calculandoHoras = true;

        const dto = { data_inicio: this.dataSelecionada, data_fim: this.dataSelecionada };
        const { data: response } = await this.$http.get('/rep/historico', { params: dto });

        if (response.success === false) {
          throw new Error(response.message);
        }

        this.horasRep = response.registros[0].quantidade;
      } catch(e) {
        console.error(e);
        this.notificar('Ocorreu um erro ao carregar as batidas do REP.', 'apontamentos');
      } finally {
        this.calculandoHoras = false;
      }
    },

    async carregarCompetencia() {
      const dtoPeriodo = { data_inicio: this.dataSelecionada, data_fim: this.dataSelecionada };
      const { data: response } = await this.$http.get('/competencia/validar', { params: dtoPeriodo });

      this.competenciaBloqueada = response.status[0].bloqueada;
    },

    processarSugestoes(data) {
      const sugestoes = this.getRegistrosDiferentes(data);

      sugestoes.map((sugestao) => {
        this.apontamentos.push({
          ...sugestao,
          duracao: 0,
          status: null,
          sugestao: true,
        });
      });
    },

    getRegistrosDiferentes(data) {
      const sugestoes = [];

      data.map((sugestao) => {
        const repetidos = this.apontamentos.filter((apontamento) => apontamento.demanda_id === sugestao.issue_id);

        if (!repetidos.length) {
          sugestoes.push(sugestao)
        }
      });

      return sugestoes;
    },


    /**
     * Edição
     */
    editar(item) {
      this.apontamento = item;
    },

    duplicarApontamento(item) {
      // Mantido para compatibilidade, mas não usado mais
      const novo = {
        ...item,
        id: null,
        duracao: 0,
        status: null,
        descricao: '',
        inicio: '',
        termino: '',
        log_duracao: '',
        sugestao: true,
      };
      this.apontamentos.push(novo);
    },

    async duplicarApontamentoEmData({ apontamento, date }) {
      // Se a data for igual à atual, apenas duplica normalmente
      if (date === this.dataSelecionada) {
        this.duplicarApontamento(apontamento);
        return;
      }
      // Troca a data, espera carregar, então duplica
      this.data = date;
      // Aguarda o carregamento dos apontamentos
      this.$nextTick(async () => {
        // Aguarda o carregamento terminar
        const waitForLoad = () => new Promise(resolve => {
          const check = () => {
            if (!this.carregando) resolve();
            else setTimeout(check, 50);
          };
          check();
        });
        await waitForLoad();
        this.duplicarApontamento(apontamento);
      });
    },

    selectDate(date) {
      this.data = date;
    }
  },
}
</script>
